export const heroSliderContent = {
  en: {
    products: [
      { id: 'drivers-license', name: 'International Driver', price: 49 },
      { id: 'boater-license', name: 'Boater License', price: 49 },
      { id: 'press-card', name: 'Press ID Card', price: 49 },
      { id: 'photo-id', name: 'Photo ID Card', price: 49 },
      { id: 'state-id', name: 'State ID Card', price: 49 },
      { id: 'student-id', name: 'Student ID Card', price: 49 },
      { id: 'national-id', name: 'National ID Card', price: 49 },
    ],
    viewAll: 'View all Models',
  },
  de: {
    products: [
      { id: 'drivers-license', name: 'Int. Führerschein', price: 49 },
      { id: 'boater-license', name: 'Bootsführerschein', price: 49 },
      { id: 'press-card', name: 'Presseausweis', price: 49 },
      { id: 'photo-id', name: 'Lichtbildausweis', price: 49 },
      { id: 'state-id', name: 'Staatsausweis', price: 49 },
      { id: 'student-id', name: 'Studentenausweis', price: 49 },
      { id: 'national-id', name: 'Personalausweis', price: 49 },
    ],
    viewAll: 'Alle Modelle ansehen',
  },
  es: {
    products: [
      { id: 'drivers-license', name: 'Licencia Internacional', price: 49 },
      { id: 'boater-license', name: 'Licencia Náutica', price: 49 },
      { id: 'press-card', name: 'Carnet de Prensa', price: 49 },
      { id: 'photo-id', name: 'Carnet con Foto', price: 49 },
      { id: 'state-id', name: 'ID Estatal', price: 49 },
      { id: 'student-id', name: 'Carnet Estudiantil', price: 49 },
      { id: 'national-id', name: 'DNI', price: 49 },
    ],
    viewAll: 'Ver todos los Modelos',
  },
  fr: {
    products: [
      { id: 'drivers-license', name: 'Permis International', price: 49 },
      { id: 'boater-license', name: 'Permis Bateau', price: 49 },
      { id: 'press-card', name: 'Carte de Presse', price: 49 },
      { id: 'photo-id', name: 'Carte Photo ID', price: 49 },
      { id: 'state-id', name: 'Carte d\'État', price: 49 },
      { id: 'student-id', name: 'Carte Étudiant', price: 49 },
      { id: 'national-id', name: 'Carte d\'Identité', price: 49 },
    ],
    viewAll: 'Voir tous les Modèles',
  },
  it: {
    products: [
      { id: 'drivers-license', name: 'Patente Internaz.', price: 49 },
      { id: 'boater-license', name: 'Patente Nautica', price: 49 },
      { id: 'press-card', name: 'Tessera Stampa', price: 49 },
      { id: 'photo-id', name: 'Tessera con Foto', price: 49 },
      { id: 'state-id', name: 'Carta d\'Identità', price: 49 },
      { id: 'student-id', name: 'Tessera Studente', price: 49 },
      { id: 'national-id', name: 'Carta Nazionale', price: 49 },
    ],
    viewAll: 'Vedi tutti i Modelli',
  },
  pt: {
    products: [
      { id: 'drivers-license', name: 'Carteira Internacional', price: 49 },
      { id: 'boater-license', name: 'Habilitação Náutica', price: 49 },
      { id: 'press-card', name: 'Cartão de Imprensa', price: 49 },
      { id: 'photo-id', name: 'Cartão com Foto', price: 49 },
      { id: 'state-id', name: 'ID Estadual', price: 49 },
      { id: 'student-id', name: 'Cartão Estudantil', price: 49 },
      { id: 'national-id', name: 'RG Nacional', price: 49 },
    ],
    viewAll: 'Ver todos os Modelos',
  },
  ru: {
    products: [
      { id: 'drivers-license', name: 'Междунар. Права', price: 49 },
      { id: 'boater-license', name: 'Права на Лодку', price: 49 },
      { id: 'press-card', name: 'Пресс-Карта', price: 49 },
      { id: 'photo-id', name: 'Фото ID Карта', price: 49 },
      { id: 'state-id', name: 'Гос. Удостоверение', price: 49 },
      { id: 'student-id', name: 'Студ. Билет', price: 49 },
      { id: 'national-id', name: 'Нац. ID Карта', price: 49 },
    ],
    viewAll: 'Смотреть все Модели',
  },
  sv: {
    products: [
      { id: 'drivers-license', name: 'Int. Körkort', price: 49 },
      { id: 'boater-license', name: 'Båtkörkort', price: 49 },
      { id: 'press-card', name: 'Presslegitimation', price: 49 },
      { id: 'photo-id', name: 'Foto-ID Kort', price: 49 },
      { id: 'state-id', name: 'Statligt ID', price: 49 },
      { id: 'student-id', name: 'Studentlegitimation', price: 49 },
      { id: 'national-id', name: 'Nationellt ID', price: 49 },
    ],
    viewAll: 'Visa alla Modeller',
  },
  zh: {
    products: [
      { id: 'drivers-license', name: '国际驾照', price: 49 },
      { id: 'boater-license', name: '船舶驾照', price: 49 },
      { id: 'press-card', name: '记者证', price: 49 },
      { id: 'photo-id', name: '照片ID卡', price: 49 },
      { id: 'state-id', name: '州身份证', price: 49 },
      { id: 'student-id', name: '学生证', price: 49 },
      { id: 'national-id', name: '国民身份证', price: 49 },
    ],
    viewAll: '查看所有型号',
  },
};
